import React from "react";

function NmapCommandField({value, onChange}) {

    const handleChange = (value) => {
        onChange(value);
    }

    return (
        <div className="network-scan-control-v2">
                <label className="network-scan-control-label-v2" htmlFor="scanCommand">Command</label>
                <input className="network-scan-input-v2"
                  id="scanCommand"
                  type="text"
                  value={value}
                  onChange={event => handleChange(event.target.value)} />
        </div>
    );
}


export default NmapCommandField;
